/** Map of ISO 4217 currency codes to their display symbols. Extensible. */
export const CURRENCY_SYMBOL_MAP: Record<string, string> = {
  LKR: 'Rs',
  USD: '$',
  EUR: '€',
  GBP: '£',
  INR: '₹',
  AUD: 'A$',
  JPY: '¥',
  SGD: 'S$',
  AED: 'AED',
  SAR: 'SAR',
  THB: '฿',
  MYR: 'RM',
  CNY: '¥',
}

/** Get the display symbol for a currency code. Falls back to the code itself. */
export function getCurrencySymbol(code: string): string {
  return CURRENCY_SYMBOL_MAP[code.toUpperCase()] ?? code.toUpperCase()
}

export function formatPrice(
  price: number | null | undefined,
  currencyCode: string = 'LKR'
): string {
  const validPrice = typeof price === 'number' && !isNaN(price) ? price : 0
  const symbol = getCurrencySymbol(currencyCode)
  return `${symbol} ${validPrice.toLocaleString('en-US')}`
}

export function formatDate(
  date: Date | string,
  options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }
): string {
  const dateObj = typeof date === 'string' ? new Date(date) : date
  return new Intl.DateTimeFormat('en-US', options).format(dateObj)
}

export function formatPhoneNumber(phone: string): string {
  const cleaned = phone.replace(/\D/g, '')
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`
  }
  return phone
}

export function formatMobileForBackend(phoneNumber: string, countryCode: string = '+94'): string {
  let cleaned = phoneNumber.replace(/\D/g, '')

  if (cleaned.startsWith('0')) {
    cleaned = cleaned.slice(1)
  }

  const codeDigits = countryCode.replace(/\D/g, '')
  if (cleaned.startsWith(codeDigits)) {
    cleaned = cleaned.slice(codeDigits.length)
  }

  return `${countryCode}${cleaned}`
}

export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text
  return `${text.slice(0, maxLength)}...`
}

export function capitalize(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
}
